import { ShipmentType } from "types/MultiStop";

const ShipmentTypes: { [key in keyof typeof ShipmentType]: ShipmentType } = {
  REGULAR: ShipmentType.REGULAR,
  CONSOLIDATED: ShipmentType.CONSOLIDATED,
  MULTIDROP: ShipmentType.MULTIDROP,
  MULTISTOP: ShipmentType.MULTISTOP,
} as const;

export default ShipmentTypes;
